export default {
  title: 'Mit PayPal bezahlen',
  error: 'Die PayPal-Zahlung konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
};
